import { ExcelColumn } from '../../../../../../generic/hooks/useExportToExcel'
import { IReportQ10Body, IReportQ10Meta } from '../../../../../../modules/API/Reports/models/q10'

export const buildQ10ExcelColumns = (
  meta: IReportQ10Meta
): ExcelColumn<IReportQ10Body>[] =>
  Object.entries(meta)
    .filter(([, label]) => label.trim() !== '')
    .map(([key, label]) => ({
      header: label,
      accessor: (row: IReportQ10Body) => {
        const value = row[key as keyof IReportQ10Body]
        return typeof value !== 'string' ? value.toFixed(1) : value
      },
    }))
